import CustomAppTypes from '../config/customAppTypes';
import { ContextReducer } from '../reducers/context';
import { UserReducer } from '../reducers/user';

const linkKeys = {
    web: 'returnLinkWeb',
    mobilbank: 'returnLinkMobile',
    mittkort: 'returnLinkMyCard',
};

const directAppTypes = [CustomAppTypes.AGRI, CustomAppTypes.EIKA, CustomAppTypes.NAF];

const getReturnLinkKey = (user: UserReducer, context: ContextReducer): string => {
    const isDirect = directAppTypes.includes(context.appType);
    if (isDirect && user.channel === 'web') return linkKeys.mobilbank;
    if (isDirect && user.channel === 'native') return linkKeys.mittkort;
    if (user.channel === 'mobilbank') return linkKeys.mobilbank;
    return linkKeys.web;
};

const abortKeys = {
    web: 'abortUrlWeb',
    mobilbank: 'abortUrlMobile',
    mittkort: 'abortUrlMyCard',
};

export const getAbortUrlKey = (user: UserReducer, context: ContextReducer): string => {
    const isDirect = directAppTypes.includes(context.appType);
    if (isDirect && user.channel === 'web') return abortKeys.mobilbank;
    if (isDirect && user.channel === 'native') return abortKeys.mittkort;
    if (user.channel === 'mobilbank') return abortKeys.mobilbank;
    return abortKeys.web;
};

export const customFailed = (errorName: string) => ({
    code: '',
    message: '',
    name: '',
    stack: '',
    status: 0,
    type: '',
    url: '',
    errorName,
});

export default getReturnLinkKey;
